import zopaTheme from './zopa';
import { staticTheme } from '@/utils/theme';
import johnLewisMoneyTheme from './jl-money';
import { type NextRouter, useRouter } from 'next/router';
import type { NextFont } from 'next/dist/compiled/@next/font';

export type AppSpecificCopy = {
  footer?: {
    customFooterLinks?: {
      links: { href: string; text: string }[];
      heading: string;
    }[];
    mainCustomLegalCopy?: string[] | string;
  };
  pages: {
    index: {
      marketingAdditional: string;
      subtitle: string;
      consents: string;
      title: string;
    };
  };
  annualIncome: {
    subtitle: string;
    title: string;
  };
  dependants: {
    subtitle: string;
    title: string;
  };
};

export function getTheme(router: NextRouter) {
  const themeName = staticTheme().theme;
  const isCobranded =
    themeName === 'jl-money' &&
    (router.pathname.includes('cancelled') ||
      router.pathname.includes('sorry') ||
      router.pathname.includes('404') ||
      router.pathname.includes('500'));

  return {
    font:
      themeName === 'jl-money' && !isCobranded
        ? (johnLewisMoneyTheme.typography.font as NextFont)
        : zopaTheme.typography.font,
    copy: themeName === 'zopa' ? zopaTheme.copy : johnLewisMoneyTheme.copy,
    theme: themeName === 'jl-money' ? johnLewisMoneyTheme : zopaTheme,
    partnerName: themeName,
    isCobranded,
  } as const;
}

export function useTheme() {
  const router = useRouter();
  return getTheme(router);
}
